export function getFCMToken(state) {
    return state.UserReducer.fcmToken;
}